import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import {ROLES} from "../../shared/interfaces";
import {ISessionState} from "../../shared/interfaces/isession-state";
import {SessionService} from "../../shared/services/session.service";
import {AlertPopupService} from "../../shared/services/alert-popup.service";

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate {
	constructor(
		private sessionService: SessionService,
		private router: Router,
		private alertPopupService: AlertPopupService,
	) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	):
		| Observable<boolean | UrlTree>
		| Promise<boolean | UrlTree>
		| boolean
		| UrlTree {
		return new Promise((resolve) => {
			this.sessionService.state$
				.pipe(take(1))
				.subscribe((state: ISessionState|null) => {
					try {
						if (state) {
							const isUser = state.token && state.profile && state.profile.role === ROLES[0];

							if (isUser) {
								resolve(isUser);
							} else {
								throw 'Please login to access this page';
							}
						} else {
							throw 'Please login to access this page';
						}
					} catch (e) {
						this.alertPopupService.showWarningAlert(`${e}`);
						this.router.navigate(['login']);
					}
				});
		});
	}
}
